var baseURL = "/admin";
var playlists = "".concat(baseURL, "/playlists");
var tracks = "".concat(baseURL, "/tracks");
var users = "".concat(baseURL, "/users");
var clients = "".concat(users, "/clients");
var musicArchives = "".concat(baseURL, "/music-archives");
var playlistsBusinessTypes = "".concat(baseURL, "/playlists-business-types");
export var admin = {
    home: function () { return clients; },
    playlists: {
        index: function () { return playlists; },
        edit: function (id) { return "".concat(playlists, "/").concat(id, "/edit"); },
    },
    musicArchives: {
        index: function () { return musicArchives; },
        edit: function (id) { return "".concat(musicArchives, "/").concat(id, "/edit"); },
    },
    tracks: {
        index: function () { return tracks; },
        edit: function (id) { return "".concat(tracks, "/").concat(id, "/edit"); },
        upload: function () { return "".concat(tracks, "/upload"); },
    },
    clients: {
        index: function () { return clients; },
        view: function (id) { return "".concat(clients, "/").concat(id); },
    },
    playlistsBusinessTypes: {
        viewAny: function () { return playlistsBusinessTypes; },
    },
};
